export const environment = {
  production: false,
  backendPath: "https://ppanel.ici-test.org"
};
